module.exports = __webpack_public_path__ + "static/chrome_logo-9c4dbb901e36beef1f7987956a629bf0.png";